import * as React from "react";
import { Footer as FlowBiteFooter } from 'flowbite-react';

export default function Footer() {
  return (
    <FlowBiteFooter container>
      <div className="w-full text-center">
        <FlowBiteFooter.Copyright
          by="The Two Circles"
          href="/"
          year={2023}
        />
      </div>
    </FlowBiteFooter>
  )
}


